import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/atas'

class GestaoAtaApiClient {
	async buscarListagemHistoricoProrrogacao(parametro) {
		const { filtro, paginacao } = parametro
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/vigencia`,
			pagingAndSorting: paginacao,
		}).buildFiltroPadraoEAvancado()

		return await axios.get(`${url}&idAta=${filtro.idAta}`)
	}

	async excluirProrrogacao(idProrrogacao) {
		return await axios.delete(`${URL_PATH}/prorrogar/${idProrrogacao}/excluir`)
	}

	async buscarItensAtaBotaoHistorico({ idAta }) {
		return await axios.get(`${URL_PATH}/vigencia/itens?idAta=${idAta}`)
	}
}

export default new GestaoAtaApiClient()
